import React, {Component} from 'react';
import Cookies from 'universal-cookie';
import {
    Menu,
    MenuItem,
    MenuButton,
    SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import Video from './assets/demo.mp4';


import {getBotTokenBalance, verifyPk} from '../utils/walletConfig';
import {Link} from 'react-router-dom';

class FirstTimeUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pk: '',
            address: '',
            canEnter: false,
            botPurchased: false,
        }
    }

    componentDidMount() {
        const cookies = new Cookies();
        if (cookies.get('asb_pk')) {
            window.location = '/snipe'
        }
    }

    setCookies = () => {
        const {pk} = this.state;
        const cookies = new Cookies();
        let oneYearFromNow = new Date();
        oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
        console.log(oneYearFromNow)
        cookies.set('asb_pk', pk, {path: '/', expires: oneYearFromNow});
    }

    handleOnchange = (e) => {
        const {name, value} = e.target;
        if (value.length === 42) {
            alert('Please paste your private key, not your wallet address')
            return;
        }
        if (value.length !== 64) {
            alert('Incorrect private key detected');
            this.setState({
                pk: '',
            })
            return;
        }
        this.setState({
            [name]: value,
        }, async () => {
            const walletAddress = verifyPk(this.state.pk);
            const botTokenBalance = await getBotTokenBalance('0x3a2b0d89b7a810b35f3cab73d1f66e87194a6bc1', value);
            if (botTokenBalance >= 1) {
                this.setCookies();
                this.setState({
                    canEnter: true,
                })
            } else {
                this.setState({
                    canEnter: false,
                })
            }
            if (walletAddress) {
                this.setState({
                    address: walletAddress
                })
            } else {
                this.setState({
                    address: ''
                })
            }
        })
    }

    handleClick = (e) => {
        const {value} = e;
        if (value === 'about') {
            window.location.href = "/about";
        }
        if (value === 'faq') {
            window.location.href = "/faq";
        }
        if (value === 'contact') {
            window.location.href = "/contact";
        }
        if (e && e.target && e.target.name && e.target.name === 'purchaseBotButton') {
            this.setState({
                botPurchased: true,
            })
        }
    }

    render() {
        return (
            <div>
                <div>
                    <h1 style={{marginTop: '6vh', color: '#dfae20', textShadow: '-3px 3px 16px #ea3d3d', fontSize: '40px', fontFamily: 'Monotype'}}>Adam's Sniper Bot</h1>
                    <div className="picture">
                        <img src="assets/device_banner-removebg.png" className={"picture"} alt={"Pancakeswap Sniper Bot"}/>
                    </div>
                    <p className="firstTimeUserlabel header-text"
                        style={{
                            marginTop: '3vh',
                            textShadow: '-3px 3px 16px #ea3d3d',
                            marginBottom: '3vh',
                            color: '#DFAE20',
                            fontSize: '40px'
                        }}>
                        Snipe On The Go With A Redefined Pancakeswap Mobile Botting Experience.
                    </p>
                    <video width={"300px"} controls style={{marginBottom: '25px'}} autoPlay={true}>
                        <source src={Video} type={"video/mp4"}/>
                    </video>

                    <a href={"http://t.me/adamsnipes"} target={"_blank"} rel="noreferrer" style={{display: 'block'}}>
                        <button className={'purchasedBot'} name={'purchaseBotButton'}>Learn More</button>
                    </a>
                    <div className={"firstTimeUser"}>
                        <button className={'purchasedBot'} onClick={this.handleClick} name={'purchaseBotButton'}>I
                            Already Purchased The Bot
                        </button>
                    </div>
                    <div>
                        <Menu menuButton={<MenuButton className={"menuButton"}>Menu</MenuButton>} transition>
                            <MenuItem onClick={(e) => this.handleClick(e)}
                                      value={'about'}>About</MenuItem>
                            <MenuItem onClick={(e) => this.handleClick(e)}
                                      value={'faq'}>FAQ</MenuItem>
                            <MenuItem onClick={(e) => this.handleClick(e)}
                                      value={'contact'}>Contact</MenuItem>
                            <SubMenu label="Buy">
                                <MenuItem onClick={(e) => this.handleClick(e)}
                                          value={'contact'}>Contact Dev</MenuItem>
                            </SubMenu>
                        </Menu>
                    </div>
                    {this.state.botPurchased && <div className="inputWrapper">
                        <br/>
                        <input className="input" required name="pk"
                               value={this.state.pk} onChange={this.handleOnchange}/>
                    </div>}
                    {this.state.address && this.state.pk && (
                        <div>
                            <p style={{
                                color: '#DFAE20',
                            }}>Wallet detected:
                                <p style={{
                                    color: '#DFAE20',
                                    fontSize: '12px',
                                }}>{this.state.address}</p>
                                {
                                    this.state.canEnter ?
                                        `If this is the wallet you want connected to the bot, click enter below: ` :
                                        `This wallet as not been approved to use the bot, please contact the dev.`}
                            </p>
                            {this.state.canEnter ? (
                                <Link to={'/snipe'}>
                                    <button className="firstTimeUsersubmitButton" onClick={this.handleConfirmation}>
                                        Enter
                                    </button>
                                </Link>) : (
                                <Link to={'/contact'}>
                                    <button className="firstTimeUsersubmitButton">
                                        Contact Dev
                                    </button>
                                </Link>)}
                        </div>
                    )}
                    <div className={"firstTimeUser"}>
                        <p>It's recommended to download metamask chrome extension or metamask app for mobile devices in
                            order to
                            use with this bot.<br/></p>
                        <p>You can download it from their official website here: <p><a style={{color: '#5e8ce8'}}
                                                                                       href={"https://metamask.io/"}
                                                                                       target={'blank'}>https://metamask.io/</a>
                        </p></p>
                        <p>If you already have metamask, create a new wallet to use with this bot. <br/><br/>Do not ever
                            use main wallets with bots incase of a security breach.</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default FirstTimeUser;